import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {
    SocietyDocMasterCreateBulkRequestDTO,
  SocietyDocMasterCreateRequestDTO,
  SocietyDocMasterDeleteRequestDTO,
  SocietyDocMasterDTO,
  SocietyDocMasterList,
  SocietyDocMasterReadByIdRequestDTO,
  SocietyDocMasterReadByMasterIdRequestDTO,
  SocietyDocMasterUpdateRequestDTO,
} from "./society-doc-master.interface";
import { Observable } from "rxjs";
import {
  SocietyDocMaster_Create,
  SocietyDocMaster_CreateBulk,
  SocietyDocMaster_Delete,
  SocietyDocMaster_ExternalCreateBulk,
  SocietyDocMaster_ExternalReadByMasterId,
  SocietyDocMaster_ReadAll,
  SocietyDocMaster_ReadById,
  SocietyDocMaster_ReadByMasterId,
  SocietyDocMaster_Update,
} from "src/app/GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class SocietyDocMasterService {
  private http = inject(HttpClient);

  SocietyDocMaster_Create(
    data: SocietyDocMasterCreateRequestDTO
  ): Observable<SocietyDocMasterDTO> {
    return this.http.post<SocietyDocMasterDTO>(SocietyDocMaster_Create, data);
  }

  SocietyDocMaster_Update(
    data: SocietyDocMasterUpdateRequestDTO
  ): Observable<SocietyDocMasterDTO> {
    return this.http.post<SocietyDocMasterDTO>(SocietyDocMaster_Update, data);
  }

  SocietyDocMaster_Delete(
    data: SocietyDocMasterDeleteRequestDTO
  ): Observable<void> {
    return this.http.post<void>(SocietyDocMaster_Delete, data);
  }

  SocietyDocMaster_ReadAll(): Observable<SocietyDocMasterList> {
    return this.http.get<SocietyDocMasterList>(SocietyDocMaster_ReadAll);
  }

  SocietyDocMaster_ReadById(
    data: SocietyDocMasterReadByIdRequestDTO
  ): Observable<SocietyDocMasterList> {
    return this.http.post<SocietyDocMasterList>(
      SocietyDocMaster_ReadById,
      data
    );
  }

  SocietyDocMaster_ReadByMasterId(
    data: SocietyDocMasterReadByMasterIdRequestDTO
  ): Observable<SocietyDocMasterList> {
    return this.http.post<SocietyDocMasterList>(
      SocietyDocMaster_ReadByMasterId,
      data
    );
  }

  SocietyDocMaster_ExternalReadByMasterId(
    data: SocietyDocMasterReadByMasterIdRequestDTO
  ): Observable<SocietyDocMasterList> {
    return this.http.post<SocietyDocMasterList>(
      SocietyDocMaster_ExternalReadByMasterId,
      data
    );
  }

  SocietyDocMaster_CreateBulk(
    data: SocietyDocMasterCreateBulkRequestDTO
  ): Observable<SocietyDocMasterList> {
    return this.http.post<SocietyDocMasterList>(
      SocietyDocMaster_CreateBulk,
      data
    );
  }

  SocietyDocMaster_ExternalCreateBulk(
    data: SocietyDocMasterCreateBulkRequestDTO
  ): Observable<SocietyDocMasterList> {
    return this.http.post<SocietyDocMasterList>(
      SocietyDocMaster_ExternalCreateBulk,
      data
    );
  }
}
